<!--
非滑动pop
用法：
slot处放置页面
-->

<template>
	<div class="mypop_unslider_box" >
		
		<div v-if="isShowPop" @click="close" class="zindex1 fixed left0 top0 bottom0 opacity5 fullwidth fullheight bg_black" >
		</div>
		<div v-if="isShowPop" :style="'top:'+windowTop+'px;overflow:auto;'" class="padding15 zindex2 fixed  bottom0 right0 width550r maxwidthp80 fullheight bg_white" >
			<div class="hidden padding10 border inline" @click="close">关闭</div> 
			<slot></slot>
		</div>
		
	</div>
</template>

<script>
	export default {
		name:'mypop-unslider',
		props:{
			// // 传入的数值
			// isShowPop :{
			// 	type:Boolean,
			// 	default: false
			// },
			// list:{
			// 	type:Array,
			// 	default: function(){return [];}
			// }, 
			
		},
		data() {
			return {
				windowTop:0,
				isShowPop:false
			}
		},
		computed:{
			/**
			 * 是否包含子级
			 */
			hasNext : function(){
				return true;
			},
			
		},
		watch:{
			// 监听list变化,否则无法更新
			list :{
				handler: function(val,oldVal){
					// console.log("--------------",val);
				},
				deep: true, //当需要监听对象的改变时，此时就需要设置deep为true, 新增、删除属性无法监听
				//immediate: true, //如果我们想在第一次绑定的时候执行此监听函数 则需要 设置immediate为true
			},
			
			// 是否选中状态
			checked : function(val){
				this.curChecked = val;
			}
		},
		created:function(){
			// console.log("comparison" , this.comparison , this.comparison.hasChilren , this.s);
			// console.log("user=>" , this.sHasChildren , this.item[this.sHasChildren]);
			this.windowTop=0;//uni.getSystemInfoSync().windowTop;
		},
		methods:{
			/** 
			 * 点击当前项的执行方法
			 * @param {Object} item
			 */
			clickItem : function (item){
				console.log(item);
				//this.$emit("clickItemxx" , item , this.hasNext);
				uni.$emit("updateIsShowChild",item);
			},
			close(){
				console.log("pop close");
				this.isShowPop=false;
			},
			open(){
				console.log("mypop-unslider show");
				this.isShowPop=true;
			}
			
		}
	}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/mypop-unslider/mypop-unslider.vue